// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2MItJ","title":"Images90_title__ygvEH","images":"Images90_images__3Zypa"};